<template>
    <div>
        <div v-if="! invoiced">
            <b>{{ item.subject.name }}</b>
            <a v-if="item.subject && ! item.subject.is_archived" :title="Lang.get('messages.openCourseDetail')" :href="'/admin/kurz/' + item.subject.id">
                <i class="fa fa-eye"></i>
            </a>
            <span class="text-muted" v-if="item.subject.code">({{ item.subject.code}})</span>
<!--            <span class="text-muted" v-if="item.listingDate">({{ item.listingDate }})</span>-->
            <button class="btn btn-default btn-sm ml-1"
                    @click.prevent="editing = true"
                    v-if="! editing && ! note"
                    :title="Lang.get('messages.addNote')"
                    v-text="Lang.get('messages.note')">
            </button>
            <div v-if="editing">
                <textarea class="form-control mt-2 mb-3" name="" id="" rows="3" v-model="note"></textarea>
                <button class="btn btn-primary mb-3" @click.prevent="updateNote" v-text="Lang.get('messages.form.save')"></button>
                <button class="btn btn-default mb-3" @click.prevent="cancel" v-text="Lang.get('messages.form.cancel')"></button>
            </div>
            <div v-if="! editing && note" class="text-muted mt-3 mb-3">
                {{ note }}
                <br>
                <button class="btn btn-default btn-sm mt-3"
                        @click.prevent="editing = true"
                        :title="Lang.get('messages.editNote')"
                        v-text="Lang.get('messsages.note')">
                </button>
            </div>
        </div>
        <div v-else>
            <b>{{ item.subject.name }}</b>
<!--            <span class="text-muted" v-if="item.listingDate">({{ item.listingDate }})</span>-->
            <span class="text-muted" v-if="item.subject.code">({{ item.subject.code}})</span>
            <div v-if="note" class="text-muted mt-3 mb-3">
                {{ note }}
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['item'],

        data() {
            return {
                editing: false,
                invoiced: false,
                note: ''
            }
        },

        methods: {
            updateNote() {
                axios.patch('/admin/orders/items/' + this.item.id + '/institution', { status_note: this.note })
                    .then(response => {
                        flash(Lang.get('messages.orderNoteForInstitution.success'));

                        this.editing = false;
                    })
                    .catch(errors => {
                        console.log(errors.response.data);
                        flash(Lang.get('messages.orderNoteForInstitution.error'), 'danger')
                    });
            },

            cancel() {
                this.editing = false;
                this.note = this.item.status_note;
            }
        },

        created() {
            this.note = this.item.status_note;
            this.invoiced = this.item.status_manager === 'billed';
        }
    }
</script>
